/* eslint-disable jsx-a11y/img-redundant-alt */
import "../styles/Aboutus.css";
import Photo1 from "../Images/AboutUs/111.jpg";
import { ArrowUpOutlined } from "@ant-design/icons";
import { animateScroll as scroll } from "react-scroll"; // Import the scroll function
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const AboutUs = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const { t } = useTranslation();
  const scrollToTop = () => {
    scroll.scrollToTop(); // Scroll to the top of the page
  };
  const [showScrollButton, setShowScrollButton] = useState(false);
  const handleScroll = () => {
    if (window.scrollY > window.innerHeight) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="ALL">
      <div className="Text-Top">
        <h1 className="Text-About">{t("AboutA")}</h1>
        <div>
          <img src={Photo1} alt="image" className="image" />
        </div>
        <h1 className="Text-About">{t("AboutB")}</h1>
      </div>
      {showScrollButton && (
        <Button
          type="primary"
          className="scroll-to-top-button"
          onClick={scrollToTop} // Add onClick handler for scrolling to top
        >
          <ArrowUpOutlined />
        </Button>
      )}
    </div>
  );
};

export default AboutUs;
